import dayjs from 'dayjs'
import format from 'dayjs/plugin/localizedFormat'
import { marked } from 'marked'
dayjs.extend(format)

tag post-tag

	get hasMedia
		data.imageUrl or data.videoUrl

	<self.post-tag>
		<div.container .flipped=flipped .full-width=!hasMedia>
			<div.left-panel>
				<div.title> data.title
				<div.published> dayjs(data.publishDate).format('ll')
				<div.body innerHTML=marked.parse(data.body or '')>
			if hasMedia
				<div.right-panel style="background-image:url({data.imageUrl})">
					if data.videoUrl
						<div.video>
							<iframe.video-iframe
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowfullscreen
								loading="lazy"
								title=data.title
								src=data.videoUrl>

css
	.post-tag
		my:4em
		d:flex
		jc:center
	.container
		d:flex
		w: 75%
		shadow: 0px 0px 20px rgba(0,0,0,.25)
		rd:lg
		rd@lt-lg:0
		fld@lt-lg:column-reverse

		&.flipped
			fld:row-reverse
			fld@lt-lg:column-reverse
			.right-panel
				rdr:unset
				rdl:lg
				rdl@lt-lg:0

		# No hero image or video — let the text fill the full width
		&.full-width
			.left-panel
				flb:100%
				min-height:unset

	.left-panel
		d:flex
		fld:column
		flb:50%
		min-height:450px
		p:1em 2em 2em 2em
		fs@xs:1em
		fs@sm:1.1em
		fs@md:1.25em
		fs@lg:1.50em
		fs@xl:1.75em
		min-height@lt-lg:unset
		
	.right-panel
		rdr:lg
		rdr@lt-lg:0
		d:flex
		flb:50%
		bgr:no-repeat
		bgp:50%
		bgs:cover
		min-height@lt-lg:400px
	
	.video
		d:flex
		flg:1
		of:hidden
		
		.video-iframe
			flg:1
			my:-6em
			

	.title
		fs:1.5em
		font-style:italic
		lh:1em
		ff:serif
		my:0

	.published
		c:cooler9/25%
		fw:bold
		font-style:italic
		fs:.9em

	.body
		mt:1em
		c:rgba(0,0,0,.75)

